import React from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import { HubHookFormWrapper, PageContent } from "../../components";
import { useGetShipmentDetails, useUpdateShipment } from "../../hooks";

import ShipmentBuilderContent from "./ShipmentBuilderContent";

export const ShipmentBuilderPage = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetShipmentDetails(id);
  const { mutate: update } = useUpdateShipment();

  const onSubmit = (formData) => {
    const payload = {
      id,
      name: formData?.name,
      templateId: formData?.templateId,
      userId: formData?.userId,
      boxerId: formData?.boxerId,
      packages: Number(formData?.boxes),
      weight: Number(formData?.weight),
      notes: formData?.notes,
      shipDate: dayjs(formData?.shipDate).toISOString(),
      purchaserId: formData?.purchaserId,
      receiverId: formData?.receiverId,
      billTo: formData?.billToId,
      shipTo: formData?.shipToId,
      items: formData?.items?.map((i) => ({
        id: i.id,
        label: i?.label,
        description: i?.description,
      })),
    };
    update(payload);
  };

  const defaultValues = {
    name: data?.name,
    templateId: data?.templateId,
    userId: data?.userId,
    boxerId: data?.boxerId,
    boxes: data?.boxes,
    weight: data?.weight,
    notes: data?.notes,
    shipDate: data?.shipDate,
    items: data?.items,

    purchaserId: data?.purchaserId,
    receiverId: data?.receiverId,
    billToId: data?.billToId,
    shipToId: data?.shipToId,
  };

  return (
    <PageContent disablePadding>
      <HubHookFormWrapper
        onSubmit={onSubmit}
        sx={{ height: "100%" }}
        defaultValues={defaultValues}
      >
        <ShipmentBuilderContent
          id={id}
          data={data}
          isLoading={isLoading}
          disabled={isLoading}
          locationId={data?.locationId}
        />
      </HubHookFormWrapper>
    </PageContent>
  );
};

export default ShipmentBuilderPage;
